<!--Modal: Login / Register Form-->
<div mdbModal #formDataUser="mdb-modal" class="modal fade modal-overflow" id="modalLRForm" tabindex="-1" role="dialog"
     aria-labelledby="myModalLabel" aria-hidden="true" (onShow)="loadUser()" [config]="{backdrop: true, ignoreBackdropClick: true}">
  <div class="modal-dialog cascading-modal" role="document">
    <!--Content-->
    <div class="modal-content">
      <!--Header-->
      <div class="modal-header darken-3">
        <h5 class="modal-title w-100"><i class="fas fa-user-circle"></i> Mis datos</h5>
        <button type="button" class="close close-movil waves-effect waves-light" data-dismiss="modal" aria-label="Close"
                (click)="formDataUser.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <!--Body-->
      <div class="modal-body mb-0">
        <form [formGroup]="formUser" [ngClass]="{disabled: true}">
          <!--Datos del usuario-->
          <fieldset>
            <legend>Datos del usuario</legend>
            <div class="row no-gutters">
              <div class="col-12">
                <div class="md-form">
                  <input mdbInput type="text" id="usName" class="form-control"
                        formControlName="defaultFormName"
                        [(ngModel)]="user.nombre">
                  <label for="usName" class="">Nombre</label>
                  <div *ngIf="formUser.controls['defaultFormName'].dirty">
                    <div *ngIf="formUser.controls['defaultFormName'].errors?.required"
                        class="text-danger animated fadeInDown fast-4 small">
                      El nombre del usuario es obligatorio.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row no-gutters">
              <div class="col-12">
                <div class="md-form">
                  <input mdbInput type="text" id="first_name" class="form-control"
                        formControlName="defaultFormFirstName"
                        [(ngModel)]="user.apellido_p">
                  <label for="first_name" class="">Apellido paterno</label>
                  <div *ngIf="formUser.controls['defaultFormFirstName'].dirty">
                    <div *ngIf="formUser.controls['defaultFormFirstName'].errors?.required"
                        class="text-danger animated fadeInDown fast-4 small">
                      El apellido paterno del usuario es obligatorio.
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="md-form">
                  <input mdbInput type="text" id="last_name" class="form-control"
                        formControlName="defaultFormLastName"
                        [(ngModel)]="user.apellido_m">
                  <label for="last_name" class="">Apellido materno</label>
                  <div *ngIf="formUser.controls['defaultFormLastName'].dirty">
                    <div *ngIf="formUser.controls['defaultFormLastName'].errors?.required"
                        class="text-danger animated fadeInDown fast-4 small">
                      El apellido materno del usuario es obligatorio.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row no-gutters">
              <div class="col-12">
                <div class="md-form">
                  <input mdbInput type="text" id="email" class="form-control" disabled
                        formControlName="defaultFormEmail"
                        [(ngModel)]="user.correo">
                  <label for="email" class="">Correo electrónico</label>
                  <div *ngIf="formUser.controls['defaultFormEmail'].dirty">
                    <div *ngIf="formUser.controls['defaultFormEmail'].errors?.required"
                        class="text-danger animated fadeInDown fast-4 small">
                      El correo electrónico del usuario es obligatorio.
                    </div>
                    <div *ngIf="formUser.controls['defaultFormEmail'].errors?.email"
                        class="text-danger animated fadeInDown fast-4 small">
                      El formato del correo electrónico es incorrecto.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="md-form">
                  <input mdbInput type="text" id="telephone" class="form-control" [(ngModel)]="user.telefono"
                        [ngModelOptions]="{standalone: true}">
                  <label for="telephone" class="">Número telefónico</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="md-form">
                  <input mdbInput type="text" id="rfc" class="form-control" [(ngModel)]="user.rfc"
                        formControlName="defaultRFC" >
                  <label for="rfc" class="">RFC</label>
                  <div *ngIf="formUser.controls['defaultRFC'].dirty">
                    <div *ngIf="formUser.controls['defaultRFC'].errors?.pattern"
                        class="text-danger animated fadeInDown fast-4 small">
                      Formato de RFC incorrecto.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <br>
          <!--Datos de la empresa-->
          <fieldset>
            <legend>Datos de la empresa</legend>
            <div class="row no-gutters">
              <div class="col-12">
                <div class="md-form">
                  <input mdbInput type="text" id="emp_nombreForm" class="form-control"
                        formControlName="emp_nombreForm"
                        [(ngModel)]="user.emp_nombre">
                  <label for="emp_nombreForm" class="">Razón social</label>
                  <div *ngIf="formUser.controls['emp_nombreForm'].touched">
                    <div *ngIf="formUser.controls['emp_nombreForm'].errors?.maxlength"
                        class="text-danger animated fadeInDown fast-4 small">El campo tiene que ser menor de 100
                      caracteres
                    </div>
                  </div>                                                          
                </div>
              </div>                                            
            </div>
            <div class="row no-gutters">
              <div class="col-12">
                <div class="md-form">
                  <input mdbInput type="text" id="emp_correoForm" class="form-control"
                        formControlName="emp_correoForm"
                        [(ngModel)]="user.emp_correo">
                  <label for="emp_correoForm" class="">Correo electrónico</label>  
                  <div *ngIf="formUser.controls['emp_correoForm'].touched">                        
                    <div *ngIf="formUser.controls['emp_correoForm'].errors?.pattern"
                        class="text-danger animated fadeInDown fast-4 small">
                      El formato del correo electrónico es incorrecto
                    </div>
                  </div>   

                </div>
              </div> 
            </div>
            <div class="row no-gutters">
              <div class="col-12">
                <div class="md-form">
                  <input mdbInput type="text" id="emp_telefonoForm" class="form-control"
                        formControlName="emp_telefonoForm"
                        [(ngModel)]="user.emp_telefono">
                  <label for="emp_telefonoForm" class="">Número telefónico</label>
                  <div *ngIf="formUser.controls['emp_telefonoForm'].touched">
                    <div *ngIf="formUser.controls['emp_telefonoForm'].errors?.maxlength"
                        class="text-danger animated fadeInDown fast-4 small">El campo tiene que ser menor de 10
                      caracteres
                    </div>
                  </div>                                                        
                </div>
              </div> 
            </div>
            <div class="row no-gutters">
              <div class="col-12">
                <div class="md-form">
                  <input mdbInput type="text" id="emp_direccionForm" class="form-control"
                        formControlName="emp_direccionForm"
                        [(ngModel)]="user.emp_direccion">
                  <label for="emp_direccionForm" class="">Dirección</label>
                  <div *ngIf="formUser.controls['emp_direccionForm'].touched">
                    <div *ngIf="formUser.controls['emp_direccionForm'].errors?.maxlength"
                        class="text-danger animated fadeInDown fast-4 small">El campo tiene que ser menor de 250
                      caracteres
                    </div>
                  </div>                                                          
                </div>
              </div>              
            </div>     
          </fieldset>
        </form>
      </div>
      <!--/.Content-->
    </div>
  </div>
  <!--Modal: Login / Register Form-->
</div>
